import AddIcon from "@mui/icons-material/Add";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { Card, FormHelperText, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import CustomTextField from "../../../components/CustomTextField";
import CustomSelect from "../../../components/Select/Select";
import { getServices } from "../../../redux/reducers/clinicSlice";
import {
  createTreatmentBundles,
  getTreatmentBundles,
  updateTreatmentBundleById,
} from "../../../redux/reducers/planSlice";
import { AppColors } from "../../../util/AppColors";
import {
  petTypes,
  planServiceTypes,
  planTypes,
  typeList,
} from "../../../util/dropList";
import { getTotalEstimatedCost } from "../../../util/function";

const cardSty = {
  borderRadius: 1,
  paddingLeft: 2,
  paddingRight: 2,
  paddingTop: 1,
  paddingBottom: 1,
  borderTopColor: AppColors.appPrimary,
};
const plusBtn = { color: AppColors.appPrimary, width: 15, height: 15 };
const initItem = { name: "", quantity: "1", cost: 0, isEdit: true };
const initValues = {
  bundleName: "",
  species: [],
  consultationType: [],
  serviceType: null,
  usageType: null,
  description: "",
  treatList: [{ ...initItem, i: 0 }],
  presList: [{ ...initItem, i: 0 }],
};
const requiredFields = [
  "bundleName",
  "species",
  "consultationType",
  "serviceType",
  "usageType",
];

const TreatmentCreate = ({ setCreateVsble, selectedPlan, setSelectedPlan }) => {
  const dispatch = useDispatch();
  const [planValues, setPlanValues] = useState(initValues);
  const [planErrs, setPlanErrs] = useState({});
  const [planHlps, setPlanHlps] = useState({});
  const [treatOpen, setTreatOpen] = useState(true);
  const [presOpen, setPresOpen] = useState(true);
  const [treatErr, setTreatErr] = useState(false);
  const stocks = useSelector((state) => state?.clinic?.clinicStocks);
  const services = useSelector((state) => state?.clinic?.services);

  useEffect(() => {
    // dispatch(getClinicStocks());
    dispatch(getServices());
  }, []);

  useEffect(() => {
    if (!selectedPlan) return;
    const reqObj = {
      bundleName: selectedPlan?.bundleName,
      species: selectedPlan?.species,
      consultationType: selectedPlan?.consulationType,
      description: selectedPlan?.description,
      serviceType: selectedPlan?.serviceType,
      usageType: selectedPlan?.usageType,
    };
    // if (selectedPlan?.usageType === "Multi Use") {
    //   reqObj.frequency = selectedPlan?.frequency;
    // }
    let treatList = [];
    let presList = [];
    if (selectedPlan?.treatmentBundleDetails?.length > 0) {
      treatList = selectedPlan?.treatmentBundleDetails?.map((det) => {
        return {
          detailId: det?.detailId,
          name: det?.name,
          cost: det?.estimatedCost ?? 0,
          initCost: det?.estimatedCost,
          quantity: det?.quantity,
          stockId: det?.stockId ?? null,
          serviceId: det?.serviceId ?? null,
          batchId: det?.batchId ?? null,
        };
      });
    }
    // if (selectedPlan?.treatmentBundlePrescription?.length > 0) {
    //   presList = selectedPlan?.treatmentBundlePrescription?.map((pre) => {
    //     const reqfreq = [];
    //     if (pre?.morning) reqfreq.push("morning");
    //     if (pre?.afternoon) reqfreq.push("afternoon");
    //     if (pre?.night) reqfreq.push("night");
    //     const customFrequency = !pre?.morning && !pre?.afternoon && !pre?.night;
    //     const reqObj = {
    //       prescriptionId: pre?.prescriptionId,
    //       administered: pre?.administered,
    //       type: pre?.type,
    //       name: pre?.name,
    //       stockId: pre?.stockId,
    //       batchId: pre?.batchId,
    //       qty: pre?.quantity,
    //       dosage: pre?.dosage,
    //       duration: pre?.duration,
    //       meal: pre?.meal,
    //       subUnit: pre?.subUnit,
    //       frequency:
    //         !pre?.morning && !pre?.afternoon && !pre?.night
    //           ? pre?.frequencyDuration
    //           : reqfreq,
    //       customFrequency,
    //       cost: 0,
    //     };
    //     if (pre?.stockId && pre?.batchId) {
    //       const reqCost =
    //         Number(
    //           getStockBatch(pre?.stockId, pre?.batchId)?.unitSellingPrice
    //         ) * (Number(pre?.quantity) ?? 1);
    //       reqObj.cost = reqCost;
    //     }

    //     return reqObj;
    //   });
    // }
    reqObj.treatList = treatList;
    reqObj.presList = presList;
    setPlanValues(reqObj);
  }, [selectedPlan]);

  const handleChange = (name, value) => {
    setPlanValues({ ...planValues, [name]: value });
    setPlanErrs({
      ...planErrs,
      [name]:
        value?.length > 0
          ? false
          : requiredFields?.find((fld) => fld === name)
          ? true
          : false,
    });
    setPlanHlps({
      ...planHlps,
      [name]:
        value?.length > 0
          ? ""
          : requiredFields?.find((fld) => fld === name)
          ? "This field is required"
          : "",
    });
  };

  const handleTreatOpen = () => {
    setTreatOpen(!treatOpen);
  };

  const handlePresOpen = () => {
    setPresOpen(!presOpen);
  };

  const handleAddTask = (typ) => {
    let treatList = planValues?.treatList;
    let presList = planValues?.presList;
    if (typ === "treatment") {
      const reqList = [
        ...planValues?.treatList,
        { ...initItem, i: planValues?.treatList?.length },
      ];
      treatList = reqList;
    }
    if (typ === "prescribe") {
      const reqList = [
        ...planValues?.presList,
        { ...initItem, i: planValues?.presList?.length },
      ];
      presList = reqList;
    }
    setPlanValues({ ...planValues, treatList, presList });
  };

  const handleAdminEditSave = (ind, value) => {
    // if (selectedPlan && !value) {
    //   const reqObj = planValues?.treatList?.find((li, i) => i === ind);
    //   if (reqObj?.detailId) {
    //     const reqApiObj = { detailId: reqObj?.detailId };
    //     reqApiObj.data = {
    //       name: reqObj?.name,
    //       quantity: Number(reqObj?.quantity) > 0 ? Number(reqObj?.quantity) : 1,
    //       estimatedCost: Number(reqObj?.cost),
    //       stockId: reqObj?.stockId ?? null,
    //       serviceId: reqObj?.serviceId ?? null,
    //     };
    //     dispatch(updateTreatmentByDetailId(reqApiObj)).then((res) => {
    //       if (res?.payload) {
    //         const reqList = planValues?.treatList?.map((li, i) => {
    //           if (i === ind) return { ...li, isEdit: value };
    //           return li;
    //         });
    //         setPlanValues({ ...planValues, treatList: reqList });
    //       }
    //     });
    //   }
    //   return;
    // }
    const reqList = planValues?.treatList?.map((li, i) => {
      if (i === ind) return { ...li, isEdit: value };
      return li;
    });
    setPlanValues({ ...planValues, treatList: reqList });
  };

  const handleAdminDelete = (ind) => {
    // if (selectedPlan) {
    //   const reqObj = planValues?.treatList?.find((li, i) => i === ind);
    //   if (reqObj?.detailId) {
    //     dispatch(deleteTreatmentBundleByDetailId(reqObj?.detailId)).then(
    //       (res) => {
    //         if (res?.payload) {
    //           const reqList = planValues?.treatList
    //             ?.filter((li, i) => i !== ind)
    //             ?.map((li, i) => {
    //               return { ...li, i };
    //             });
    //           setPlanValues({ ...planValues, treatList: reqList });
    //         }
    //       }
    //     );
    //   }
    //   return;
    // }
    const reqList = planValues?.treatList
      ?.filter((li, i) => i !== ind)
      ?.map((li, i) => {
        return { ...li, i };
      });
    setPlanValues({ ...planValues, treatList: reqList });
  };

  const handlePresDelete = (ind) => {
    // if (selectedPlan) {
    //   const reqObj = planValues?.presList?.find((li, i) => i === ind);
    //   if (reqObj?.prescriptionId) {
    //     dispatch(
    //       deleteBundlePrescriptionByDetailId(reqObj?.prescriptionId)
    //     ).then((res) => {
    //       if (res?.payload) {
    //         const reqList = planValues?.presList
    //           ?.filter((li, i) => i !== ind)
    //           ?.map((li, i) => {
    //             return { ...li, i };
    //           });
    //         setPlanValues({ ...planValues, presList: reqList });
    //       }
    //     });
    //   }
    //   return;
    // }
    const reqList = planValues?.presList
      ?.filter((li, i) => i !== ind)
      ?.map((li, i) => {
        return { ...li, i };
      });
    setPlanValues({ ...planValues, presList: reqList });
  };

  const getStockBatch = (stockId, batchId) => {
    const selStock = stocks?.data?.find((stc) => stc?.stockId === stockId);
    const reqBatc = selStock?.stockBatch?.find(
      (btch) => btch?.batchId === batchId
    );
    return reqBatc;
  };

  const handleAdminChange = (name, value, ind, addObj) => {
    const reqList = planValues?.treatList?.map((li, i) => {
      if (i === ind) {
        const reqObj = { ...li, [name]: value };
        if (name === "name") {
          reqObj.stockId = addObj?.stockId;
          reqObj.batchId = addObj?.batchId;
          reqObj.serviceId = addObj?.serviceId;
          reqObj.category = addObj?.category;
          if (addObj?.stockId) {
            const reqBatch = addObj?.batchId
              ? getStockBatch(addObj?.stockId, addObj?.batchId)
              : stocks?.data?.find((stc) => stc?.stockId === addObj?.stockId)
                  ?.stockBatch?.[0];
            const reqCost =
              Number(reqBatch?.unitSellingPrice) * Number(li?.quantity ?? 1);
            reqObj.cost = reqCost;
          }
          if (addObj?.serviceId) {
            const reqService = services?.data?.find(
              (ser) => ser?.serviceId === addObj?.serviceId
            );
            if (reqService) reqObj.cost = reqService?.servicePrice;
          }
        }
        if (name === "quantity") {
          if (li?.stockId) {
            const reqBatch = li?.batchId
              ? stocks?.data
                  ?.find((stc) => stc?.stockId === li?.stockId)
                  ?.stockBatch?.find((bat) => bat?.batchId === li?.batchId)
              : stocks?.data?.find((stc) => stc?.stockId === li?.stockId)
                  ?.stockBatch?.[0];
            const reqCost =
              (Number(reqBatch?.unitSellingPrice) ?? 0) * (Number(value) ?? 1);
            reqObj.cost = reqCost;
          }
          if (li?.serviceId) {
            reqObj.cost =
              (Number(
                services?.data?.find((ser) => ser?.serviceId === li?.serviceId)
                  ?.servicePrice
              ) ?? 0) * (Number(value) ?? 1);
          }
          if (!li?.stockId && !li?.batchId && !li?.serviceId) {
            const reqCost =
              Number(li?.initCost ?? li?.cost) * Number(value ?? 1);
            reqObj.cost = reqCost;
          }
        }
        return reqObj;
      }
      return li;
    });
    setPlanValues({ ...planValues, treatList: reqList });
  };

  const handlePresChange = (name, value, ind, addObj) => {
    const reqList = planValues?.presList?.map((li, i) => {
      if (i === ind) {
        const reqObj = { ...li, [name]: value };
        if (name === "name") {
          reqObj.stockId = addObj?.stockId;
          reqObj.batchId = addObj?.batchId;
          reqObj.type = addObj?.type;
          if (addObj?.stockId && addObj?.batchId) {
            const reqCost =
              Number(
                getStockBatch(addObj?.stockId, addObj?.batchId)
                  ?.unitSellingPrice
              ) * Number(li?.quantity ?? 1);
            reqObj.cost = reqCost;
          }
        }
        // if (name === "qty") {
        //   const reqCost =
        //     (Number(li?.cost) > 0 ? Number(li?.cost) : 0) * Number(value);
        //   reqObj.cost = reqCost;
        // }
        if (name === "frequency") {
          if (value?.includes("Custom")) {
            reqObj.frequency = "";
            reqObj.customFrequency = true;
          }
        }
        if (name === "quantity") {
          if (li?.stockId && li?.batchId) {
            const reqCost =
              Number(
                getStockBatch(li?.stockId, li?.batchId)?.unitSellingPrice
              ) * Number(value ?? 1);
            reqObj.cost = reqCost;
          }
          if (!li?.stockId && !li?.batchId) {
            const reqCost = Number(li?.initCost) * Number(value ?? 1);
            reqObj.cost = reqCost;
          }
        }
        return reqObj;
      }
      return li;
    });
    setPlanValues({ ...planValues, presList: reqList });
  };

  const handlePresEditSave = (ind, value) => {
    // if (selectedPlan && !value) {
    //   const reqObj = planValues?.presList?.find((li, i) => i === ind);
    //   if (reqObj?.prescriptionId) {
    //     const reqApiObj = { prescriptionId: reqObj?.prescriptionId };
    //     reqApiObj.data = {
    //       administered: "Prescribed",
    //       type: reqObj?.type ?? null,
    //       name: reqObj?.name ?? "",
    //       stockId: reqObj?.stockId,
    //       batchId: reqObj?.batchId ?? null,
    //       quantity:
    //         typeof reqObj?.qty === "undefined" ? 1 : Number(reqObj?.qty),
    //       dosage: reqObj?.dosage ?? "",
    //       duration: reqObj?.duration ?? "",
    //       meal: reqObj?.meal,
    //       subUnit: "Unit",
    //       morning:
    //         (reqObj?.frequency?.includes("morning") &&
    //           !reqObj?.frequency?.includes("Custom")) ??
    //         false,
    //       afternoon:
    //         (reqObj?.frequency?.includes("afternoon") &&
    //           !reqObj?.frequency?.includes("Custom")) ??
    //         false,
    //       night:
    //         (reqObj?.frequency?.includes("night") &&
    //           !reqObj?.frequency?.includes("Custom")) ??
    //         false,
    //     };
    //     if (typeof reqObj?.frequency === "string") {
    //       reqObj.frequencyDuration = reqObj?.frequency;
    //     }
    //     dispatch(updateTreatmentPrescriptionById(reqApiObj)).then((res) => {
    //       if (res?.payload) {
    //         const reqList = planValues?.presList?.map((li, i) => {
    //           if (i === ind) return { ...li, isEdit: value };
    //           return li;
    //         });
    //         setPlanValues({ ...planValues, presList: reqList });
    //       }
    //     });
    //   }
    //   return;
    // }
    const reqList = planValues?.presList?.map((li, i) => {
      if (i === ind) return { ...li, isEdit: value };
      return li;
    });
    setPlanValues({ ...planValues, presList: reqList });
  };

  const handleBackClick = () => {
    dispatch(getTreatmentBundles());
    setPlanValues(initValues);
    setCreateVsble(false);
    setSelectedPlan(null);
  };

  const getList = (isPrescription = false) => {
    const reqList = [];
    // if (stocks?.data?.length > 0) {
    //   stocks?.data?.forEach((dta) => {
    //     const batch = dta?.stockBatch?.find((btch) => btch?.quantity > 0);
    //     if (batch) {
    //       reqList.push({
    //         name: dta?.tradeName,
    //         value: dta?.tradeName,
    //         stockId: dta?.stockId,
    //         type: dta?.category,
    //         batchId: batch?.batchId,
    //         unitSellingPrice: batch?.unitSellingPrice,
    //       });
    //     }
    //   });
    // }
    if (services?.data?.length > 0 && !isPrescription) {
      services?.data?.forEach((ser) =>
        reqList.push({
          ...ser,
          name: ser?.serviceName,
          value: ser?.serviceName,
        })
      );
    }
    return reqList;
  };

  const handleValidate = () => {
    let errs = {};
    let hlps = {};
    requiredFields?.forEach((fld) => {
      const reqValue = planValues?.[fld];
      if (!reqValue || reqValue?.length === 0) {
        errs = { ...errs, [fld]: true };
        hlps = { ...hlps, [fld]: "This is field is required" };
      }
    });
    setPlanErrs(errs);
    setPlanHlps(hlps);
    return Object.keys(errs)?.length > 0;
  };

  const handleSave = () => {
    if (handleValidate()) return;
    if (
      planValues?.treatList?.length === 0 ||
      planValues?.treatList?.some(
        (li) =>
          li?.name?.length === 0 ||
          li?.name === "" ||
          Number(li?.quantity) === 0 ||
          li?.quantity === ""
      )
    ) {
      return setTreatErr(true);
    }
    const treatmentDetails = [];
    if (planValues?.treatList?.length > 0) {
      planValues?.treatList?.forEach((li) => {
        const reqObj = {
          name: li?.name,
          quantity: Number(li?.quantity ?? 1),
          estimatedCost: Number(li?.cost) ?? 0,
          bundleId: li?.category,
        };
        if (li?.serviceId) reqObj.serviceId = li?.serviceId;
        if (li?.stockId) reqObj.stockId = li?.stockId;
        if (li?.detailId) reqObj.detailId = li?.detailId;
        treatmentDetails.push(reqObj);
      });
    }
    // let treatmentPrescription = [];
    // if (planValues?.presList?.length > 0) {
    //   treatmentPrescription = planValues?.presList?.map((pre) => {
    //     const reqObj = {
    //       // administered: false,
    //       administered: "Prescribed",
    //       type: pre?.type ?? null,
    //       name: pre?.name ?? "",
    //       stockId: pre?.stockId,
    //       batchId: pre?.batchId ?? null,
    //       quantity: typeof pre?.qty === "undefined" ? 1 : Number(pre?.qty),
    //       dosage: pre?.dosage ?? "",
    //       duration: pre?.duration ?? "",
    //       meal: pre?.meal,
    //       subUnit: "Unit",
    //       morning:
    //         (pre?.frequency?.includes("morning") &&
    //           !pre?.frequency?.includes("Custom")) ??
    //         false,
    //       afternoon:
    //         (pre?.frequency?.includes("afternoon") &&
    //           !pre?.frequency?.includes("Custom")) ??
    //         false,
    //       night:
    //         (pre?.frequency?.includes("night") &&
    //           !pre?.frequency?.includes("Custom")) ??
    //         false,
    //     };
    //     if (typeof pre?.frequency === "string") {
    //       reqObj.frequencyDuration = pre?.frequency;
    //     }
    //     if (pre?.prescriptionId) {
    //       reqObj.prescriptionId = pre?.prescriptionId;
    //     }
    //     return reqObj;
    //   });
    // }
    const data = {
      bundleName: planValues?.bundleName,
      species: planValues?.species,
      consulationType: planValues?.consultationType,
      serviceType: planValues?.serviceType,
      usageType: planValues?.usageType,
      description: planValues?.description,
      treatmentDetails,
      treatmentPrescription: [],
    };
    // if (planValues?.usageType === "Multi Use") {
    //   data.frequency =
    //     Number(planValues?.frequency) > 0 ? Number(planValues?.frequency) : 1;
    // }
    // if (treatmentPrescription?.length > 0) {
    //   data.treatmentPrescription = treatmentPrescription;
    // }
    if (selectedPlan) {
      dispatch(
        updateTreatmentBundleById({ planId: selectedPlan?.treatmentId, data })
      ).then((res) => {
        if (res?.payload) handleBackClick();
      });
    } else {
      dispatch(createTreatmentBundles(data)).then((res) => {
        if (res?.payload) handleBackClick();
      });
    }
  };

  const getBatchList = (stockId = null) => {
    if (!stockId) return [];
    const reqStock = stocks?.data?.find((stc) => stc?.stockId === stockId);
    if (!reqStock) return [];
    const filteredBatches = reqStock?.stockBatch
      ?.filter(
        (btch) => btch?.billlable === "Y"
        // && btch?.quantity > 0
      )
      ?.map((btch) => ({
        name: btch?.batchNo,
        value: btch?.batchNo,
        batchId: btch?.batchId,
        salesUom: btch?.salesUom,
      }));
    return filteredBatches;
  };

  return (
    <>
      <div className="flex-row-ali-cen mt10">
        <div className="ml50 cursor" onClick={handleBackClick}>
          <div className="flex-row-ali-cen">
            <ArrowBackIosIcon
              sx={{ color: AppColors.appPrimary, width: 20, height: 20 }}
            />
            <Typography className="fs16 txt-semi-bold blue-color ml5">
              Back
            </Typography>
          </div>
        </div>
        <div className="pos-absolute r50">
          <div>
            <CustomButton text="Save" smallBtn onClick={handleSave} />
          </div>
        </div>
      </div>

      <div className="scroll-70vh">
        <Grid container spacing={0} className="flex-center">
          <Grid item xs={12} sm={12} md={8} lg={6} xl={6}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="txt-semi-bold fs14 blue-color">
                  Bundle Name <span className="red-color">*</span>
                </div>
                <CustomTextField
                  value={planValues?.bundleName}
                  handleChange={(e) =>
                    handleChange("bundleName", e?.target?.value)
                  }
                  fullWidth
                  error={planErrs?.bundleName}
                  helperText={planHlps?.bundleName}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                <div className="txt-semi-bold fs14 blue-color">
                  Species <span className="red-color">*</span>
                </div>
                <CustomSelect
                  list={petTypes}
                  value={planValues?.species}
                  handleChange={(e) =>
                    handleChange("species", e?.target?.value)
                  }
                  multiSelectTagCheck
                  error={planErrs?.species}
                  helperText={planHlps?.species}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                <div className="txt-semi-bold fs14 blue-color">
                  Consultation Type <span className="red-color">*</span>
                </div>
                <CustomSelect
                  list={typeList}
                  value={planValues?.consultationType}
                  handleChange={(e) =>
                    handleChange("consultationType", e?.target?.value)
                  }
                  multiSelectTagCheck
                  error={planErrs?.consultationType}
                  helperText={planHlps?.consultationType}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                <div className="txt-semi-bold fs14 blue-color">
                  Service Type <span className="red-color">*</span>
                </div>
                <CustomSelect
                  list={planServiceTypes}
                  value={planValues?.serviceType ?? null}
                  handleChange={(e) =>
                    handleChange("serviceType", e?.target?.value)
                  }
                  select
                  error={planErrs?.serviceType}
                  helperText={planHlps?.serviceType}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
                <div className="txt-semi-bold fs14 blue-color">
                  Usage <span className="red-color">*</span>
                </div>
                <CustomSelect
                  list={planTypes}
                  value={planValues?.usageType ?? null}
                  handleChange={(e) =>
                    handleChange("usageType", e?.target?.value)
                  }
                  select
                  error={planErrs?.usageType}
                  helperText={planHlps?.usageType}
                />
              </Grid>
              {/* {planValues?.usageType === "Multi Use" ? (
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="txt-semi-bold fs14 blue-color">Frequency</div>
                  <CustomTextField
                    value={planValues?.frequency}
                    handleChange={(e) =>
                      handleChange("frequency", e?.target?.value)
                    }
                    fullWidth
                  />
                </Grid>
              ) : null} */}
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="txt-semi-bold fs14 blue-color">Description</div>
                <CustomTextField
                  value={planValues?.description}
                  handleChange={(e) =>
                    handleChange("description", e?.target?.value)
                  }
                  fullWidth
                  multiline
                />
              </Grid>
            </Grid>
            <div className="green-back4 ph20 pv10 mt20 br10">
              <div className="flex-row-between-align-center">
                <Typography className="txt-semi-bold fs14 orange5">
                  Estimated Total Cost:
                </Typography>
                <Typography className="font-bold fs14 orange5 ml10">
                  Rs{" "}
                  {Number(
                    getTotalEstimatedCost(planValues?.treatList)
                  )?.toFixed(2)}
                </Typography>
              </div>
            </div>
            <Card sx={cardSty} className="mt20">
              <div
                className="flex-row-ali-cen cursor"
                onClick={handleTreatOpen}
              >
                {treatOpen ? (
                  <ArrowDropDownIcon
                    sx={{ width: 30, height: 30, color: AppColors.appPrimary }}
                  />
                ) : (
                  <ArrowRightIcon
                    sx={{ width: 30, height: 30, color: AppColors.appPrimary }}
                  />
                )}
                <div className="flex-row-ali-cen">
                  <Typography className="font-bold fs14 blue-color">
                    Treatment
                  </Typography>
                  <Typography className="font-bold fs14 gray20 ml5">
                    (Add list of services used)
                  </Typography>
                </div>
              </div>
              {treatOpen ? (
                <div className="flex-column">
                  <div className="flex-row-ali-cen mh10">
                    <div className="w30Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Name
                      </Typography>
                    </div>
                    <div className="w30Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Quantity
                      </Typography>
                    </div>
                    <div className="w30Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Estimated Cost
                      </Typography>
                    </div>
                    <div className="w10Per" />
                  </div>
                  <div className="blue-hor-split mt5" />
                  {planValues?.treatList?.map((li, i) => {
                    return (
                      <div
                        className="flex-row-ali-cen mt10 plan-bor"
                        key={i + "admin"}
                      >
                        <div className="w30Per pr10">
                          {li?.isEdit ? (
                            <CustomSelect
                              list={getList()}
                              value={li?.name}
                              addNewSelect
                              mandatoryField
                              handleChange={(e) => {
                                handleAdminChange("name", e?.value ?? e, i, {
                                  stockId: e?.stockId ?? null,
                                  batchId: e?.batchId ?? null,
                                  serviceId: e?.serviceId ?? null,
                                  category: e?.category ?? null,
                                });
                              }}
                              plusBtn
                            />
                          ) : (
                            <Typography className="txt-regular fs12 black18">
                              {li?.name}
                            </Typography>
                          )}
                        </div>
                        <div className="w30Per pr10">
                          {li?.isEdit ? (
                            <CustomTextField
                              value={li?.quantity}
                              handleChange={(e) =>
                                handleAdminChange(
                                  "quantity",
                                  e?.target?.value,
                                  i
                                )
                              }
                              fullWidth
                              type="number"
                            />
                          ) : (
                            <Typography className="txt-regular fs12 black18">
                              {li?.quantity}
                            </Typography>
                          )}
                        </div>
                        <div className="w30Per pr10">
                          <Typography className="txt-regular fs12 gray20 ml5">
                            {Number(li?.cost) > 0 ? `Rs ${li?.cost}` : "-"}
                          </Typography>
                        </div>
                        <div className="w10Per flex-center">
                          {li?.isEdit ? (
                            <img
                              src={require("../../../assets/images/png/save.png")}
                              className="imghw30 cursor"
                              onClick={() => handleAdminEditSave(i, false)}
                            />
                          ) : (
                            <div className="flex-row-ali-cen">
                              <img
                                src={require("../../../assets/images/png/editWitTxt.png")}
                                className="imghw30 cursor"
                                onClick={() => handleAdminEditSave(i, true)}
                              />
                              <img
                                src={require("../../../assets/images/png/delete.png")}
                                className="imghw30 cursor ml10"
                                onClick={() => handleAdminDelete(i)}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                  {!selectedPlan ? (
                    <div
                      className="flex-row-ali-cen mt10 cursor"
                      onClick={() => handleAddTask("treatment")}
                    >
                      <div className="flex-center plus-icon">
                        <AddIcon sx={plusBtn} />
                      </div>
                      <Typography className="blue-color fs16 ml5 font-bold">
                        Add
                      </Typography>
                    </div>
                  ) : null}
                </div>
              ) : null}
            </Card>
            {treatErr ? (
              planValues?.treatList?.length === 0 ||
              planValues?.treatList?.some(
                (li) =>
                  li?.name?.length === 0 ||
                  li?.name === "" ||
                  Number(li?.quantity) === 0 ||
                  li?.quantity === ""
              ) ? (
                <div className="flex-center mt10">
                  <FormHelperText error>
                    Please fill all the Name and quantity fields
                  </FormHelperText>
                </div>
              ) : (
                ""
              )
            ) : null}
          </Grid>
          {/* <Grid item xs={12} sm={12} md={12} lg={10} xl={10}>
            <Card
              sx={{
                borderRadius: 1,
                paddingLeft: 2,
                paddingRight: 2,
                paddingTop: 1,
                paddingBottom: 1,
                borderTopColor: AppColors.appPrimary,
                marginLeft: 0,
                marginRight: 0,
              }}
              className="mv20"
            >
              <div className="flex-row-ali-cen cursor" onClick={handlePresOpen}>
                {presOpen ? (
                  <ArrowDropDownIcon
                    sx={{ width: 30, height: 30, color: AppColors.appPrimary }}
                  />
                ) : (
                  <ArrowRightIcon
                    sx={{ width: 30, height: 30, color: AppColors.appPrimary }}
                  />
                )}
                <div className="flex-row-ali-cen">
                  <Typography className="font-bold fs14 blue-color">
                    Prescription
                  </Typography>
                  <Typography className="font-bold fs14 gray20 ml5">
                    (optional)
                  </Typography>
                </div>
              </div>
              {presOpen ? (
                <div className="flex-column">
                  <div className="flex-row-ali-cen mh10">
                    <div className="w25Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Name
                      </Typography>
                    </div>
                    <div className="w18Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Qty
                      </Typography>
                    </div>
                    <div className="w10Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Dosage
                      </Typography>
                    </div>
                    <div className="w12Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Duration
                      </Typography>
                    </div>
                    <div className="w15Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Frequency
                      </Typography>
                    </div>
                    <div className="w15Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Instructions
                      </Typography>
                    </div>
                    <div className="w5Per" />
                  </div>
                  <div className="blue-hor-split mt5" />
                  {planValues?.presList?.map((li, i) => {
                    return (
                      <div
                        className="flex-row-ali-cen mt10 plan-bor"
                        key={i + "pres"}
                      >
                        <div className="w25Per pr10">
                          {li?.isEdit ? (
                            <CustomSelect
                              list={getList(true)}
                              value={li?.name}
                              addNewSelect
                              mandatoryField
                              handleChange={(e) => {
                                handlePresChange("name", e?.value ?? e, i, {
                                  stockId: e?.stockId ?? null,
                                  batchId: e?.batchId ?? null,
                                  type: e?.type ?? null,
                                });
                              }}
                              plusBtn
                            />
                          ) : (
                            <Typography className="txt-regular fs12 black18">
                              {li?.name}
                            </Typography>
                          )}
                        </div>
                        <div className="w18Per pr10">
                          {li?.isEdit ? (
                            <CustomTextField
                              value={li?.qty}
                              handleChange={(e) =>
                                handlePresChange("qty", e?.target?.value, i)
                              }
                              fullWidth
                              type="number"
                              endIcon
                              inputIcon={
                                getBatchList(li?.stockId)?.[0]?.salesUom ?? ""
                              }
                            />
                          ) : (
                            <Typography className="txt-regular fs12 black18">
                              {li?.qty}{" "}
                              {getBatchList(li?.stockId)?.[0]?.salesUom ?? ""}
                            </Typography>
                          )}
                        </div>
                        <div className="w10Per pr10">
                          {li?.isEdit ? (
                            <CustomTextField
                              fullWidth
                              handleChange={(e) =>
                                handlePresChange("dosage", e?.target?.value, i)
                              }
                              value={li?.dosage}
                            />
                          ) : (
                            <Typography className="txt-regular fs12 black18">
                              {li?.dosage}
                            </Typography>
                          )}
                        </div>
                        <div className="w12Per pr10">
                          {li?.isEdit ? (
                            <CustomTextField
                              fullWidth
                              handleChange={(e) =>
                                handlePresChange(
                                  "duration",
                                  e?.target?.value,
                                  i
                                )
                              }
                              value={li?.duration}
                              endIcon
                              inputIcon="days"
                            />
                          ) : (
                            <Typography className="txt-regular fs12 black18">
                              {li?.duration?.length > 0
                                ? `${li?.duration} days`
                                : ""}
                            </Typography>
                          )}
                        </div>
                        <div className="w15Per pr10">
                          {li?.isEdit ? (
                            li?.customFrequency ? (
                              <CustomTextField
                                fullWidth
                                handleChange={(e) =>
                                  handlePresChange(
                                    "frequency",
                                    e?.target?.value,
                                    i
                                  )
                                }
                                value={li?.frequency}
                              />
                            ) : (
                              <CustomSelect
                                list={frequncyCheckList}
                                value={li?.frequency ?? []}
                                handleChange={(e) => {
                                  handlePresChange(
                                    "frequency",
                                    e?.target?.value,
                                    i
                                  );
                                }}
                                multiSelectTagCheck
                              />
                            )
                          ) : (
                            <Typography
                              className={`txt-regular fs12 black18 ${
                                li?.frequency !== "string" && "capitalize"
                              }`}
                            >
                              {typeof li?.frequency === "string"
                                ? li?.frequency
                                : li?.frequency?.join(", ")}
                            </Typography>
                          )}
                        </div>
                        <div className="w15Per pr10">
                          {li?.isEdit ? (
                            <CustomSelect
                              list={mealTypes}
                              value={li?.meal}
                              select
                              handleChange={(e) => {
                                handlePresChange("meal", e?.target?.value, i);
                              }}
                            />
                          ) : (
                            <Typography className="txt-regular fs12 black18">
                              {li?.meal === "afterMeal"
                                ? "After Meal"
                                : li?.meal === "beforeMeal"
                                ? "Before Meal"
                                : ""}
                            </Typography>
                          )}
                        </div>
                        <div className="w5Per flex-center">
                          {li?.isEdit ? (
                            <img
                              src={require("../../../assets/images/png/save.png")}
                              className="imghw30 cursor"
                              onClick={() => handlePresEditSave(i, false)}
                            />
                          ) : (
                            <div className="flex-row-ali-cen">
                              <img
                                src={require("../../../assets/images/png/delete.png")}
                                className="imghw30 cursor"
                                onClick={() => handlePresDelete(i)}
                              />
                              <img
                                src={require("../../../assets/images/png/editWitTxt.png")}
                                className="imghw30 cursor ml10"
                                onClick={() => handlePresEditSave(i, true)}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                  {!selectedPlan ? (
                    <div
                      className="flex-row-ali-cen mt10 cursor"
                      onClick={() => handleAddTask("prescribe")}
                    >
                      <div className="flex-center plus-icon">
                        <AddIcon sx={plusBtn} />
                      </div>
                      <Typography className="blue-color fs16 ml5 font-bold">
                        Add
                      </Typography>
                    </div>
                  ) : null}
                </div>
              ) : null}
            </Card>
          </Grid> */}
        </Grid>
      </div>
    </>
  );
};

export default TreatmentCreate;
